module.exports = __webpack_public_path__ + "img/ent-icon.0419e586.png";